module.exports = __webpack_public_path__ + "img/99.78fdaa2e.jpg";